let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9XWAe")).then(() => parcelRequire('ckkq8'));